import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CopyUtil } from 'src/app/common/util';
import { FormTaxResponse } from 'src/app/models/tax.model';

@Component({
  selector: 'app-tax-form-four',
  templateUrl: './tax-form-four.component.html',
  styleUrls: ['./tax-form-four.component.scss']
})
export class TaxFormFourComponent {
  @Input() form: FormTaxResponse = null;

  constructor(
    private toastService: ToastrService
  ) {
  }

  copy(text) {
    CopyUtil.copy(text);
    this.toastService.info("Copiado al portapapeles!");
  }
}
